module.exports = __webpack_public_path__ + "static/media/lightbulb.50aa39cb.gif";